import { Outlet, useParams } from "react-router-dom";
import { Card, CardHeader } from "reactstrap";

import { NavTabs, TabContent } from "components/NavTabs";
import { assignmentTabOptions } from "features/assignments/constants/tabOptions";

export function AssignmentAssignmentsPageSection() {
  const { assignmentsTab, assignment_id } = useParams();
  return (
    <div className="assignment-assignments-page-section d-flex flex-fill position-relative">
      <Card className="border-0 rounded-0 flex-fill" outline body={false}>
        <CardHeader>
          <NavTabs tabs={assignmentTabOptions} />
        </CardHeader>
        <TabContent
          className="p-2"
          activeTabId={assignmentsTab}
          tabs={assignmentTabOptions}
          assignment_id={assignment_id}
        />
      </Card>
      <Outlet />
    </div>
  );
}
